import React, {Component} from 'react';
import {Col, Row,} from 'react-bootstrap';
import ForecastingMap from './ForecastingMap';
import MonthPicker from './DatePicker/MonthPicker';
import ContainerDimensions from 'react-container-dimensions';
import Card from './Card';
import {ForecastLineChart, LineChartPicker} from "./LineChart";
import MonthlyChart from "./MonthlyChart";
import moment from 'moment';
import {splitCamelCaseToWords} from '../util/strings';
import WaterAvailabilityAnalysis from "./WaterAvailabilityAnalysis";


export class Forecasts extends Component {
    constructor(props) {
        super(props);
        this.onMonthChanged = this.onMonthChanged.bind(this);
        this.state = {selectedMonth: "2001-02", isLoadingForecast: false};
        this.getLineData = this.getLineData.bind(this);
        this.updateCondition = this.updateCondition.bind(this);
        this.updateForecastsPercentiles = this.updateForecastsPercentiles.bind(this);
        this.updateForecasts = this.updateForecasts.bind(this);
        this.onMonthChanged = this.onMonthChanged.bind(this);
        this.calculateClicked = this.calculateClicked.bind(this);
    }

     async onMonthChanged(e) {
        await this.setState({selectedMonth: moment(e).format("YYYY-MM")},
            async () => {
                await this.updateCondition();
                await this.updateForecasts();
            });
    }
    
    async updateCondition() {
        const time = moment(this.state.selectedMonth).format("YYYY-MM-DD");
        console.log(time);
        let response = await fetch(`/api/Forecast/GetClassification?date=${time}&catchmentName=${this.state.selectedStationName}`);
        // convert the string to a pretty condition
        const conditions = await response.json(); 
        let speiCondition = splitCamelCaseToWords(conditions.spei);
        let flowCondition = splitCamelCaseToWords(conditions.flow);

        response = await fetch(`/api/Forecast/GetSpei?date=${time}&catchmentName=${this.state.selectedStationName}`);
        let speiValue = await response.json();
        this.setState({speiCondition: speiCondition, flowCondition: flowCondition, speiValue: speiValue});
    }

    updateForecasts() {
        const time = moment(this.state.selectedMonth).format("YYYY-MM-DD");
        this.setState({isLoadingForecast: true}, () => {
            fetch(`/api/Forecast/GetForecast?date=${time}&catchmentName=${this.state.selectedStationName}&oneMonth=${this.state.oneMonth}&threeMonths=${this.state.threeMonths}&sixMonths=${this.state.sixMonths}`)
                .then(r => r.json())
                .then(data => this.setState({forecastData: data, isLoadingForecast: false}));
        });
    }
    
    async updateForecastsPercentiles() {
        const formattedDate = "2012-10-01";
        
        let response = await fetch(`/api/forecast/GetForecastData?dateTime=${formattedDate}&catchmentName=${this.state.selectedStationName}`);
        let serverForecastData = await response.json();
        
        this.setState({ serverForecastData: serverForecastData });
    }

    calculateClicked(e) {
        this.setState({oneMonth: e.oneMonth, threeMonths: e.threeMonths, sixMonths: e.sixMonths}, () => {
            this.updateForecasts();
        });
    }

    getLineData() {
        if (this.state.percentileData)
            return [this.state.rawData.flow, this.state.rawData.rainfall, this.state.rawData.pet, this.state.rawData.spei];
        else
            return [];
    }
    
    getDisplayName(stationName) {
        if (stationName === "Bak Trakoun") {
            return "Stung Pursat at Bak Trakoun";
        } else if (stationName === "Kampong Thmar") {
            return "Stung Chinit at Kampong Thmar";
        } else {
            return "Stung Sreng at Kralanh";
        }
        
        
    }

    async selectionChanged(e) {
        const stationName = e.properties.Station;
        // get data:
        const percentileResponse = await fetch(`/api/SeriesData/GetPercentileValues/${stationName}`);
        const percentileData = await percentileResponse.json();
        
        const rawResponse = await fetch(`/api/SeriesData/GetRawValues/${stationName}`);
        const rawData = await rawResponse.json();

        this.setState({
            selectedCatchmentName: this.getDisplayName(stationName),
            selectedStationName: stationName,
            percentileData : percentileData,
            rawData : rawData
        });
        await this.updateCondition();
        await this.updateForecastsPercentiles();
    }

    render() {
        let mainForecastArea;
        if (this.state.selectedCatchmentName) {
            mainForecastArea = (
                <div>
                    <Row style={{marginTop: "20px"}}>
                        <Col md={12}>
                            <Card>
                                <LineChartPicker
                                    title={`Monthly Rainfall, PET, Flow and SPEI for subcatchment ${this.state.selectedCatchmentName}`}
                                    series={this.getLineData()}/>

                            </Card>
                        </Col>
                    </Row>
                    
                    <Row style={{marginTop: "20px"}}>
                        <Col md={12}>
                            <Card>
                                <ForecastLineChart series={this.state.rawData.flow} forecastData={this.state.serverForecastData}/>
                            </Card>
                        </Col>
                    </Row>


                        <Card>
                            <div className={"row row-eq-height"}>
                        <Col md={4}>
                                <MonthPicker value={this.state.selectedMonth} startDate={"2001-01"} endDate={"2012-10"}
                                             onChange={this.onMonthChanged}/>
                                <ConditionAssesment spei={this.state.speiValue} condition={this.state.speiCondition}
                                                    waterAvailability={this.state.flowCondition}/>
                        </Col>
                        <Col md={8}>
                                <WaterAvailabilityAnalysis click={this.calculateClicked}
                                                           forecastData={this.state.forecastData}
                                                           isLoading={this.state.isLoadingForecast}/>
                        </Col>
                            </div>
                        </Card>
                    <Row>
                        <Col md={6}>
                            <Card left>
                                <MonthlyChart title={`Monthly Flow for ${this.state.selectedCatchmentName}`}
                                              series={this.state.percentileData.flow}/>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card right>
                                <MonthlyChart title={`Monthly SPEI for ${this.state.selectedCatchmentName}`}
                                              series={this.state.rawData.spei}/>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Card left>
                                <MonthlyChart title={`Monthly PET for ${this.state.selectedCatchmentName}`}
                                              series={this.state.percentileData.pet}/>

                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card right>
                                <MonthlyChart title={`Monthly Rainfall for ${this.state.selectedCatchmentName}`}
                                              series={this.state.percentileData.rainfall}/>

                            </Card>
                        </Col>
                    </Row>
                </div>);
        }
        else {
            mainForecastArea = <h3 style={{marginTop: '50px'}}>Select a catchment on the map to begin</h3>
        }

        return (
            <div>
                <Row>
                    <Col md={12} style={{height: "400px"}}>
                        <ContainerDimensions>
                            <ForecastingMap click={this.selectionChanged.bind(this)}/>
                        </ContainerDimensions>
                    </Col>
                </Row>
                {mainForecastArea}
            </div>
        );
    }
}

function ConditionRow(props) {
    return (
        <Row>
            <Col xs={6}><strong>{props.title}</strong></Col>
            <Col xs={6}>{props.value}</Col>
        </Row>
    )
}

function ConditionAssesment(props) {
    return (
        <div>
            <h4>Drought Condition Assessment</h4>
            <ConditionRow title="SPEI" value={props.spei}/>
            <ConditionRow title="Condition" value={props.condition}/>
            <ConditionRow title="Water Availability" value={props.waterAvailability}/>
        </div>
    )
}




// WEBPACK FOOTER //
// ./src/components/Forecasts.jsx